// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';

import { VBD_EDIT_CONFIRMATION_MODAL_CONFIG } from '../../../components/common/vbd/constants';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridDeleteButton,
} from '../../../formik-utils/FieldArrayGrid';
import { useDeleteCustomDiscountsConfigLevelDiscountMutation } from '../../../service-definitions/estimates';
import { DEFAULT_VALUE_FOR_DB_ROW_ID, ROW_ID } from '../../../constants';
import { EstimateContext } from '../../../contexts/EstimateContext';
import { getIfAllMetricsAreFrozen, getIfRowIsVBD } from '../utils';

const getIfDimensionConfigDeleteButtonShouldBeDisabled = (
  readOnlyModeForDeleteButton,
  rowValues,
  formik
) => {
  if (readOnlyModeForDeleteButton) {
    return true;
  }

  // If the row is NOT frozen, then return false to enable it
  if (!rowValues?.isRowFrozen) {
    return false;
  }

  if (!getIfAllMetricsAreFrozen(formik.values)) {
    return true;
  }

  return !formik.isValid;
};

export const DimensionsConfigDeleteButtonContainer = () => {
  const [deleteMLDFunc] = useDeleteCustomDiscountsConfigLevelDiscountMutation();
  const { estimateId } = useParams();
  const { rowValues, readOnlyModeForDeleteButton } = useContext(FieldArrayGridConfigItemContext);
  const estimate = useContext(EstimateContext);
  const formik = useFormikContext();
  const isVBDRow = getIfRowIsVBD(rowValues);

  const payload = {
    estimate_id: estimateId,
    estimate_version: estimate?.inputs?.estimate_version,
    ...rowValues,
    id: rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID ? '-1' : rowValues[ROW_ID],
  };

  const deleteMLDFuncParams = {
    payload: payload,
    estimateId: estimateId,
    metricsDiscountId: rowValues?.metric_discount_id ?? -1,
  };

  const disabled = getIfDimensionConfigDeleteButtonShouldBeDisabled(
    readOnlyModeForDeleteButton,
    rowValues,
    formik
  );

  return (
    <FieldArrayGridDeleteButton
      confirmationModalConfig={VBD_EDIT_CONFIRMATION_MODAL_CONFIG}
      deleteFunc={deleteMLDFunc}
      deleteFuncParams={deleteMLDFuncParams}
      disabled={disabled}
      showConfirmationModal={isVBDRow}
    />
  );
};
